<template>
	<div>
        <g-vue-table
        :apiIndexUrl="'/api/mailinglists/'+$parent.obj.id+'/editorials'"
        :sortBy="'companyname'"
        :columns="columns"
        ref="GVueTable"
        :filtered="true"
        :creable="false"
        :obj="false"
        :actionsDropdown="actionsDropdown"
        ></g-vue-table>
	</div>
</template>

<script>
export default {
    name : 'EditorialsList',
    props : ['obj'],
    computed : {
        actionsDropdown() {
            var t = this;
            return [{
                name : this.transUC('remove from lists'),
                clicked : function(ids) {
                    t.removeFromList(ids)
                }
            }]
        }
    },
    methods : {
        updateObj(data) {
            return this.$parent.$parent.updateObj(data)
        },
        removeFromList(ids) {
            var t = this
            window.axios.post('/api/editorials/remove-from-lists', {
                mailinglists : [ t.$parent.$parent.obj.id ],
                ids : ids
            })
            .then(function() {
                t.updateObj(false)
            })
        }
    },
    data(){
        return {
            columns : [{
                name: '__checkbox',
                titleClass: 'text-center short-cell',
                dataClass: 'text-center short-cell',
                visible : true
            },{
                title: '#',
                name: 'id',
                sortField: 'id',
                titleClass: 'text-right medium-cell',
                dataClass: 'text-right medium-cell clickable',
                visible : true,
                cellClicked : function(t, data, field, event) {
                    window.axios.get('/api/editorials/'+data.id)
                    .then(function(response) {
                        t.$emit('setObj', response.data);
                    })
                }
            },{
                title : this.transUC('name'),
                name: 'companyname',
                sortField: 'companyname',
                dataClass: 'clickable',
                visible : true,
                cellClicked : function(t, data, field, event) {
                    window.axios.get('/api/editorials/'+data.id)
                    .then(function(response) {
                        t.$emit('setObj', response.data);
                    })
                },
            },{
                title : this.transUC('city'),
                name : 'city',
                sortField: 'city',
                visible : true
            },{
                title : this.transUC('publisher'),
                name: '_publisher',
                sortField: '_publisher',
                dataClass: 'clickable',
                visible : true,
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = '<a href="/#/publishers/'+match[1]+'" target="_blank">'+data[i].replace(match[0], '')+'</a>'
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                }
            },{
                title : this.transUC('periodicity'),
                name : '_periodicity',
                sortField: '_periodicity',
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
                visible : true
            },{
                title : this.transUC('category'),
                name : '_categories',
                sortField: '_categories',
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
                visible : true
            },{
                title : this.transUC('genre'),
                name : '_genres',
                sortField: '_genres',
                callback : function(data) {
                    if (data === null)
                        return null
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
                visible : true
            },{
                title : this.transUC('updated'),
                name: 'updated_at',
                sortField: 'updated_at',
                titleClass: 'text-center updated-at-cell',
                dataClass: 'text-right updated-at-cell',
                visible : true
            }],
        }
    }
}
</script>